import { FormInput } from 'src/@types';
import { getDefaultValue } from 'src/components/shared/form-elements';
import { CalculatorsHomeValueStep3FormFields } from '../../../../../@types/features/calculators';
import { IntlShape } from 'react-intl/src/types';

export const useCalculatorHomeValueStep3FormFields = (intl: IntlShape) => {
  const calculatorHomeValueStep3FormFields: Record<
    keyof CalculatorsHomeValueStep3FormFields,
    FormInput
  > = {
    buildYear: {
      fieldName: 'buildYear',
      label: intl.formatMessage({
        id: 'step3.buildYear',
        defaultMessage: 'Jaartal'
      }),
      type: 'text',
      required: true,
      placeHolder: '1995',
      defaultValue: getDefaultValue('1995')
    },
    useSurface: {
      fieldName: 'useSurface',
      label: intl.formatMessage({
        id: 'step3.useSurface',
        defaultMessage: 'Totaal woonoppervlak'
      }),
      type: 'number',
      required: true,
      placeHolder: 'm2',
      defaultValue: getDefaultValue('100')
    },
    volume: {
      fieldName: 'volume',
      label: intl.formatMessage({
        id: 'step3.volume',
        defaultMessage: 'Inhoud van de woning'
      }),
      type: 'number',
      required: true,
      placeHolder: 'm3',
      defaultValue: getDefaultValue('250')
    },
    plotSize: {
      fieldName: 'plotSize',
      required: false,
      label: intl.formatMessage({
        id: 'step3.plotSize',
        defaultMessage: 'Totaal perceeloppervlak'
      }),
      type: 'number',
      placeHolder: 'm2',
      defaultValue: getDefaultValue('200')
    }
  };
  return calculatorHomeValueStep3FormFields;
};
